/*
 * Comparison table — custom scroll indicator.
 *
 * The table scrolls horizontally on narrow screens; the design replaces the
 * native scrollbar with a pill. The indicator is hidden entirely when there is
 * nothing to scroll, so it never implies hidden content that does not exist.
 */
(function () {
  'use strict';

  class ComparisonTable extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-viewport]');
      this.progress = this.querySelector('[data-progress]');
      this.thumb = this.querySelector('[data-thumb]');
      if (!this.viewport || !this.progress || !this.thumb) return;

      this.update = this.update.bind(this);
      this.viewport.addEventListener('scroll', this.update, { passive: true });

      this.resizeObserver = new ResizeObserver(this.update);
      this.resizeObserver.observe(this.viewport);
      this.update();
    }

    disconnectedCallback() {
      if (this.viewport) this.viewport.removeEventListener('scroll', this.update);
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    update() {
      const { scrollWidth, clientWidth, scrollLeft } = this.viewport;
      const overflow = scrollWidth - clientWidth;

      // 1px tolerance: fractional layout widths never land exactly on zero.
      if (overflow <= 1) {
        this.progress.hidden = true;
        return;
      }
      this.progress.hidden = false;

      const ratio = clientWidth / scrollWidth;
      const trackWidth = this.progress.clientWidth;
      const thumbWidth = Math.max(trackWidth * ratio, 24);
      const offset = (scrollLeft / overflow) * (trackWidth - thumbWidth);

      this.thumb.style.setProperty('--cmp-thumb-width', thumbWidth + 'px');
      this.thumb.style.setProperty('--cmp-thumb-offset', offset + 'px');
    }
  }

  if (!customElements.get('comparison-table')) {
    customElements.define('comparison-table', ComparisonTable);
  }
})();
